import React, { useEffect, useState } from 'react';
import { Box, Button, CardContent, Grid, TextField, Alert, Stack } from '@mui/material';
import { IconBuilding, IconDeviceFloppy } from '@tabler/icons';

import { useHistory } from 'react-router-dom';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';

const CreateCompany = () => {
    const history = useHistory();

    const [appId, setAppId] = useState(null);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [saving, setSaving] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        cnpj: '',
        phone: '',
        email: '',
        address: ''
    });

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAppId(res.data.app.id);
            } catch (error) {
                console.error(error);
                setStatus({ type: 'error', message: 'Erro ao buscar app padrão' });
            }
        })();
    }, []);

    const backPage = () => {
        history.push('/dashboard/config/companies/view');
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!appId) {
            setStatus({ type: 'error', message: 'App não carregado ainda' });
            return;
        }

        setStatus({ type: '', message: '' });
        setSaving(true);

        try {
            const response = await api.post(`v1/apps/${appId}/companies/`, formData);
            history.push(`/dashboard/config/companies/edit/${response.data.id}`);
        } catch (error) {
            console.error(error);
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || error.response?.data?.error || 'Erro ao criar empresa.'
            });
            setSaving(false);
        }
    };

    return (
        <Box>
            <PageHeader
                icon={IconBuilding}
                gradient="graphite"
                title="Adicionar empresa"
                subtitle="A matriz é criada automaticamente junto com a empresa"
            />

            <GlassCard>
                <CardContent>
                    {status.message && (
                        <Alert severity={status.type} sx={{ mb: 2 }}>
                            {status.message}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField name="name" label="Nome" fullWidth value={formData.name} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField name="cnpj" label="CNPJ" fullWidth value={formData.cnpj} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField name="phone" label="Telefone" fullWidth value={formData.phone} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField name="email" label="Email" type="email" fullWidth value={formData.email} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField name="address" label="Endereço" fullWidth value={formData.address} onChange={handleChange} />
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                                    <Button onClick={backPage} disabled={saving}>
                                        Cancelar
                                    </Button>
                                    <Button type="submit" variant="contained" startIcon={<IconDeviceFloppy size={18} />} disabled={saving}>
                                        {saving ? 'Salvando...' : 'Criar empresa'}
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </GlassCard>
        </Box>
    );
};

export default CreateCompany;
